// Module
var code = `<section class="box">
  <sub-header header="'SSS pension file details ' + \$ctrl.fileId"></sub-header>
  <form name="\$ctrl.correctionForm" ng-if="\$ctrl.pensions && \$ctrl.pensions.length > 0">
    <table class="table" at-table at-list="\$ctrl.pensions">
      <thead></thead>
      <tbody class="tbody">
      <tr class="products-table__row">
        <td at-title="File row no">{{item.row.rowNumber}}</td>
        <td at-title="SSS number">{{item.row.sssNumber}}</td>
        <td at-title="Customer Number">{{item.customerNumber}}</td>
        <td at-title="Branch">{{item.branchId}}</td>
        <td at-title="Account number">{{item.productNumber}}</td>
        <td at-title="File account number">
          <input disabled type="text" ng-model="item.row.accountNumber"/>
        </td>
        <td at-title="Amount">{{item.row.amount | nxCurrency}}</td>
      </tr>
      </tbody>
    </table>
    <div class="summary-actions">
      <button
        type="button"
        class="btn btn-warning"
        ng-click="\$ctrl.goBack()">
        Go back
      </button>
    </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/sss-pension/summary/batch-sss-pension-summary.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;